export class UserTelegramConnectionEvent {
  idUserTelegramConnectionEvent: number | null;
  idUser: number;
  eventType: string;
  token: string | null;
  chatId: number | null;
  username: string | null;
  firstName: string | null;
  lastName: string | null;
  languageCode: string | null;
  createdAt: string;

  constructor(
    idUserTelegramConnectionEvent: number | null,
    idUser: number,
    eventType: string,
    token: string | null,
    chatId: number | null,
    username: string | null,
    firstName: string | null,
    lastName: string | null,
    languageCode: string | null,
    createdAt: string
  ) {
    this.idUserTelegramConnectionEvent = idUserTelegramConnectionEvent;
    this.idUser = idUser;
    this.eventType = eventType;
    this.token = token;
    this.chatId = chatId;
    this.username = username;
    this.firstName = firstName;
    this.lastName = lastName;
    this.languageCode = languageCode;
    this.createdAt = createdAt;
  }

  static fromRaw(raw: any): UserTelegramConnectionEvent {
    return new UserTelegramConnectionEvent(
      raw.idUserTelegramConnectionEvent ?? null,
      raw.idUser,
      String(raw.eventType),
      raw.token ?? null,
      raw.chatId ?? null,
      raw.username ?? null,
      raw.firstName ?? null,
      raw.lastName ?? null,
      raw.languageCode ?? null,
      String(raw.createdAt)
    );
  }

  clone(): UserTelegramConnectionEvent {
    return new UserTelegramConnectionEvent(
      this.idUserTelegramConnectionEvent,
      this.idUser,
      this.eventType,
      this.token,
      this.chatId,
      this.username,
      this.firstName,
      this.lastName,
      this.languageCode,
      this.createdAt
    );
  }

  toPayload(): any {
    const payload: any = {
      idUser: this.idUser,
      eventType: this.eventType,
      token: this.token,
      chatId: this.chatId,
      username: this.username,
      firstName: this.firstName,
      lastName: this.lastName,
      languageCode: this.languageCode,
      createdAt: this.createdAt
    };

    if (this.idUserTelegramConnectionEvent !== null) {
      payload.idUserTelegramConnectionEvent = this.idUserTelegramConnectionEvent;
    }

    return payload;
  }
}
